import type { ReactElement } from 'react';
import type { FieldError } from 'react-hook-form';

import { Localization } from '../Localization';
import { defaultTranslations } from '../constants/defaultTranslations_simplified-registration-BrandPartner';
import { TranslationKey } from '../models';

export const renderValidationMessage = (error: FieldError, max?: number, min?: number) => {
  let customMessage: ReactElement | string | undefined;

  switch (error.type) {
    case 'required':
      customMessage = (
        <Localization
          id={TranslationKey.validationRequired}
          defaultMessage={defaultTranslations.validationRequired}
        />
      );
      break;
    case 'maxLength':
      customMessage = (
        <Localization
          id={TranslationKey.validationMaxLength}
          defaultMessage={defaultTranslations.validationMaxLength}
          values={{ max }}
        />
      );
      break;
    case 'minLength':
      customMessage = (
        <Localization
          id={TranslationKey.validationMinLength}
          defaultMessage={defaultTranslations.validationMinLength}
          values={{ min }}
        />
      );
      break;
    case 'pattern':
      customMessage = (
        <Localization
          id={TranslationKey.validationRegex}
          defaultMessage={defaultTranslations.validationRegex}
        />
      );
      break;
    default:
      customMessage = error.message;
  }

  return customMessage;
};
